// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.target-strat {
  border: 1px solid #0c8119;
  padding: 10px;
  border-radius: 8px;
  background-color: #effcef;
  width: 310px;
  margin-right: 20px;
}

.target-goal {
  border: 1px solid #2323e5;
  background-color: #eef4ff;
}

.target-revenue {
  border: 1px solid #0c8119;
  background-color: #effcef;
}

.target-agent {
  border: 1px solid #cba000;
  background-color: #fffbec;
}

.last-week-goal {
  margin-left: auto;
}

.last-week-goal h6 {
  font-size: 10px;
  margin-bottom: 5px;
}

.last-week-goal p {
  text-align: end;
  margin-bottom: 5px;
}

.target-strat .value {
  background-color: transparent;
}

.target-strat h3 {
  font-size: 12px;
  margin-bottom: 10px;
}

.target-strat img {
  height: 30px;
  width: 30px;
}

.target-strat .value p {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 5px;
}

.target-goal .value p {
  color: #1d2e63;
}

.target-revenue .value p {
  color: #0c8119;
}

.target-strat .progress {
  background-color: #c6c6c6;
  height: 6px;
}

.target-strat .progress-bar {
  height: 6px;
}

.target-strat .value h6 {
  font-size: 10px;
}

.target-strat .current-engagement {
  border-right: 2px solid #c6c6c6;
}

.target-strat .current-engagement p {
  color: #1d2e63;
}

.target-strat .current-engagement p {
  color: #0c8119;
}

.more-info {
  border: 1px dashed #707070;
  border-radius: 29px;
  background-color: #ffffff;
  font-size: 11px;
  color: #060d27;
}

.more-info:hover {
  background-color: #EEF4FF;
}

.target-btn {
  margin-top: auto;
}

.target-type {
  width: 160px;
  padding: 20px;
  border: 1px solid;
  border-radius: 5px;
}

.active-target {
  background-color: #f4f9ff;
  border: 2px solid #0981fc;
}
`, "",{"version":3,"sources":["webpack://./src/view/reporting-dashboard/target/TargetStrategies.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B","sourcesContent":[".target-strat {\n  border: 1px solid #0c8119;\n  padding: 10px;\n  border-radius: 8px;\n  background-color: #effcef;\n  width: 310px;\n  margin-right: 20px;\n}\n\n.target-goal {\n  border: 1px solid #2323e5;\n  background-color: #eef4ff;\n}\n\n.target-revenue {\n  border: 1px solid #0c8119;\n  background-color: #effcef;\n}\n\n.target-agent {\n  border: 1px solid #cba000;\n  background-color: #fffbec;\n}\n\n.last-week-goal {\n  margin-left: auto;\n}\n\n.last-week-goal h6 {\n  font-size: 10px;\n  margin-bottom: 5px;\n}\n\n.last-week-goal p {\n  text-align: end;\n  margin-bottom: 5px;\n}\n\n.target-strat .value {\n  background-color: transparent;\n}\n\n.target-strat h3 {\n  font-size: 12px;\n  margin-bottom: 10px;\n}\n\n.target-strat img {\n  height: 30px;\n  width: 30px;\n}\n\n.target-strat .value p {\n  font-size: 22px;\n  font-weight: 600;\n  margin-bottom: 5px;\n}\n\n.target-goal .value p {\n  color: #1d2e63;\n}\n\n.target-revenue .value p {\n  color: #0c8119;\n}\n\n.target-strat .progress {\n  background-color: #c6c6c6;\n  height: 6px;\n}\n\n.target-strat .progress-bar {\n  height: 6px;\n}\n\n.target-strat .value h6 {\n  font-size: 10px;\n}\n\n.target-strat .current-engagement {\n  border-right: 2px solid #c6c6c6;\n}\n\n.target-strat .current-engagement p {\n  color: #1d2e63;\n}\n\n.target-strat .current-engagement p {\n  color: #0c8119;\n}\n\n.more-info {\n  border: 1px dashed #707070;\n  border-radius: 29px;\n  background-color: #ffffff;\n  font-size: 11px;\n  color: #060d27;\n}\n\n.more-info:hover {\n  background-color: #EEF4FF;\n}\n\n.target-btn {\n  margin-top: auto;\n}\n\n.target-type {\n  width: 160px;\n  padding: 20px;\n  border: 1px solid;\n  border-radius: 5px;\n}\n\n.active-target {\n  background-color: #f4f9ff;\n  border: 2px solid #0981fc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
